const ComponentBase = require('../../base/ComponentBase');
const CommonUtil = require('../../utils/CommonUtil');
const g2 = require('../../g2');
/**
 * @constructor
 * @classdesc 要素定位
 * @augments G.base.ComponentBase
 * @alias G.common.FeatureLocate
 * @param {Object} options 构造参数；
 * @param {G.Map} options.map 地图对象
 * @param {Array} [options.padding] 范围到边界的距离,像素单位,默认为[10,10,10,10]
 * @param {Integer} [options.maxZoom] 点要素最大缩放级别比例尺，默认为地图最大缩放级别
 * @param {Float} [options.minResolution] 点要素最小缩放级别比例尺，如指定maxZoom，则该配置项忽略
 * @param {Object} [options.duration] 动画配置
 * @param {Integer} [options.duration.move] 移动动画，毫秒
 * @param {Integer} [options.duration.zoom] 放大动画，毫秒
 * @example
 * //使用示例代码
 *         var featureLocate = new G.common.FeatureLocate({
 *             map:demo.emap,
 *             padding:[10,0,10,0],
 *             maxZoom:10
 *         });
 */
let component = ComponentBase.extend({
    options: {
        padding: [10, 10, 10, 10],
        minResolution: 0,
        maxZoom: null,
        duration: {},
        // 触发器
        nexTickTrigger: function(params, cb, ctx) {
            cb.call(ctx);
            return null;
        },
    },
    initialize(options) {
        ComponentBase.prototype.initialize.call(this, options);
        this.moveDuration = this.options.duration.move ? this.options.duration.move : 0;
        this.zoomDuration = this.options.duration.zoom ? this.options.duration.zoom : 0;
        //
        this.queue = [];
        this.timer = null;
        this.timeout = 0;
        this.running = false;
    },

    /**
     * 定位
     * @method
     * @memberOf G.common.FeatureLocate.prototype
     * @param data {Object|Array} 几何信息
     * @param data.type {String} 类型: wkt, geojson
     * @param data.geom {String} 几何对象值: wkt, geojson
     * @param options {Object} 定位相关参数
     * @param options.padding {Array}  范围到边界的距离,像素单位,默认为[10,10,10,10]
     * @param options.maxZoom {Integer} 点要素最大缩放级别比例尺，默认为地图最大缩放级别
     * @param options.minResolution {Float} 点要素最小缩放级别比例尺，如指定maxZoom，则该配置项忽略
     * @param options.duration {Object} 动画配置
     * @param options.duration.move {Integer} 移动动画，毫秒
     * @param options.duration.zoom {Integer} 放大动画，毫秒
     *
     */
    fit(data, options) {
        // 暂时先清除
        this.clear();
        this.queue.push({
            data,
            options,
        });
        if (!this.running) {
            this._nextTick();
        }
    },
    clear() {
        this.queue = [];
        this._clearTimer();
        this.timeout = 0;
        this.running = false;
        // 清理动画
        this._clearAnimation();
    },
    /**
     * 延迟执行，后续扩展多个视野定位的串行处理
     */
    _nextTick(timeout) {
        this.timer = this.options.nexTickTrigger({
            timeout,
        }, function() {
            // 清理动画
            this._clearAnimation();
            if (this.queue.length > 0) {
                let lastFit = this.queue[this.queue.length - 1];
                this.timeout = this._fit(lastFit.data, lastFit.options);
                console.debug('视野定位 timeout = ', this.timeout, '', lastFit);
                //
                this.queue.splice(this.queue.length - 1, 1);
            } else {
                this.running = false;
                this.timeout = 0;
            }
            if (this.queue.length > 0) {
                this._nextTick(this.timeout);
            }
        },  this);
    },
    /**
     * 定位
     */
    _fit(data, options) {
        options = options || {};
        //构建四至范围
        var envelope = new g2.sfs.Envelope();
        if (CommonUtil.isArray(data)) {
            var geomCollection = new g2.sfs.GeometryCollection();
            data.forEach(_data => {
                var geom = this._geometryConstructor(_data);
                envelope.union(geom.envelope());
            });
        } else if (CommonUtil.isObject(data)) {
            var geom = this._geometryConstructor(data);
            envelope = geom.envelope();
        }
        let _minResolution = this.options.minResolution;
        let _moveDuration = this.moveDuration;
        let _zoomDuration = this.zoomDuration;
        let _maxZoom = this.options.maxZoom;
        let _padding = options.padding || this.options.padding;
        if (options) {
            _maxZoom = options.maxZoom ? options.maxZoom : this.options.maxZoom;
            _minResolution = options.minResolution ? options.minResolution : this.options.minResolution;
            if (options.duration) {
                if (options.duration.move === 0) {
                    _moveDuration = 0;
                } else {
                    _moveDuration = options.duration.move ? options.duration.move : this.moveDuration;
                }
                if (options.duration.zoom === 0) {
                    _zoomDuration = 0;
                } else {
                    _zoomDuration = options.duration.zoom ? options.duration.zoom : this.zoomDuration;
                }
                _padding = options.padding ? options.padding : this.options.padding;
            }
        }
        var olView = this.map.map.getView();
        var olSize = this.map.map.getSize();
        let timeout = parseFloat(_moveDuration + _zoomDuration) || 0;
        //判断四至是否为点
        if (this._isEnvelopePoint(envelope)) {
            var _center = new g2.sfs.Point({
                x: envelope.minx,
                y: envelope.miny
            });
            if (!!_maxZoom) {
                if (timeout > 0) {
                    olView.animate({center: [_center.x, _center.y], duration: _moveDuration}, {
                        zoom: _maxZoom,
                        duration: _zoomDuration
                    });
                } else {
                    this.map.setCenter(_center);
                    this.map.zoomTo(_maxZoom);
                }
            } else if (!!_minResolution) {
                if (timeout > 0) {
                    olView.animate({
                        center: [_center.x, _center.y],
                        duration: _moveDuration
                    }, {resolution: _minResolution, duration: _zoomDuration});
                } else {
                    this.map.setCenter(_center);
                    this.map.setResolution(_minResolution);
                }
            }
            //四至为多边形
        } else {
            /**
             * 2020年3月28日 22:47:35
             * 修改视野动画的 padding参数bug
             */
            var extent = envelope;
            if (timeout > 0) {
                olView.fit([extent.minx, extent.miny, extent.maxx, extent.maxy], {
                    size: olSize,
                    padding: _padding || [10, 10, 10, 10],
                    // constrainResolution: constrainResolution == undefined ? true : constrainResolution,
                    duration: timeout,
                });
            } else {
                this.map.pan(extent, _padding || [10, 10, 10, 10]);
            }
        }
        return timeout;
    },

    _clearAnimation() {
        var olView = this.map.map.getView();
        // 目前是否有视野调整
        var currenAnimation = olView.getAnimating();
        if (currenAnimation) {
            olView.cancelAnimations();
        }
    },
    _clearTimer() {
        if (this.timer) {
            clearTimeout(this.timer);
            this.timer = null;
        }
    },
    
    _isEnvelopePoint(envelope) {
        if (envelope.maxx == envelope.minx && envelope.maxy == envelope.miny) {
            return true;
        }
        return false;
    },
    //todo：切换为使用util组件构造
    _geometryConstructor(data) {
        var geom = new g2.sfs.Geometry();
        if (data.type.toLowerCase() == "wkt") {
            geom = g2.sfs.GeometryFactory.createGeometryFromWkt(data.geom, this.map.getSrid());
        } else if (data.type.toLowerCase() == "geojson") {
            geom = g2.sfs.GeometryFactory.createGeometryFromGeoJson(data.geom, this.map.getSrid());
        }
        return geom;
    },
    /**
     * @inheritDoc
     */
    unload() {
        this.clear();
        //
        ComponentBase.prototype.unload.call(this);
    },
    /**
     * @inheritDoc
     */
    destroy() {
        //
        ComponentBase.prototype.destroy.call(this);
    }
});
module.exports = component;
